import { ReactElement, ReactNode } from 'react';

const getNodeText = (node: ReactNode | string | string[] | number | ((...props: any[]) => void)): string => {
  if (['string', 'number'].includes(typeof node)) return String(node);
  if (node instanceof Array) return node.map(getNodeText).join('');
  if (typeof node === 'object' && node && 'props' in node) return getNodeText(node.props.children as ReactElement);
  return '';
};

export default getNodeText;
